module.exports = __webpack_public_path__ + "static/6-46af605d42ae77cad76577a7c70df173.jpg";